import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'
import SummaryMarquee from '@components/Summary/SummaryMarquee'
import SummaryMarqueeItem from '@components/Summary/SummaryMarqueeItem'
import SummaryMarqueeItemLoader from '@components/Summary/SummaryMarqueeItemLoader'
import translate from '@i18n'
import { mobileCSS } from '@measures/responsive'
import { TAnswerResponse } from '@utils/chatbot/types'
import { FunctionComponent, useMemo } from 'react'
import styled, { css } from 'styled-components'

const StyledNewSummaryRequestView = styled.div`
  ${({
    theme: {
      spacing: { spacing8, spacing16, spacing24 },
      color: {
        primary: { blickRed },
      },
    },
  }) => css`
    display: flex;
    position: relative;
    margin: -${spacing8} -${spacing8} -${spacing8} -${spacing24};
    align-items: center;
    ${mobileCSS(css`
      flex-direction: column;
      gap: ${spacing16};
      justify-content: center;
      align-items: center;
      margin: -${spacing8} 0;
    `)}
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 360px;
      height: 84px;
      background: linear-gradient(
        90.68deg,
        rgba(226, 0, 0, 0) 0.58%,
        ${blickRed} 35.22%
      );

      pointer-events: none;
      z-index: 2;
      ${mobileCSS(css`
        width: 20px;
      `)}
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 20px;
      height: 84px;
      background: linear-gradient(
        270deg,
        rgba(226, 0, 0, 0) 0.58%,
        ${blickRed} 99.42%
      );

      pointer-events: none;
      z-index: 2;
      ${mobileCSS(css`
        top: 0;
        left
      `)}
    }
  `}
`

const StyledPrimaryCTAButton = styled(PrimaryCTAButton)`
  ${({
    theme: {
      color: {
        primary: { blickRed },
      },
    },
  }) => css`
    min-width: 218px;
    color: ${blickRed};
    z-index: 3;
    & > svg {
      fill: ${blickRed};
    }
  `}
`

const NewSummaryRequestView: FunctionComponent<{
  onPrimaryClick: () => void
  data?: TAnswerResponse
  loading: boolean
  hasError?: boolean
}> = ({ onPrimaryClick, data, loading, hasError }) => {
  const MarqueeContent = useMemo(() => {
    return loading
      ? Array.from(Array(3), (_, index) => (
          <SummaryMarqueeItemLoader key={`marquee-loader-${index}`} />
        ))
      : !hasError
        ? data?.content.map((item, index) => (
            <SummaryMarqueeItem
              key={`${index}-${item.category}`}
              category={item.category ?? ''}
              title={item?.link ? (data.links[item?.link].title ?? '') : ''}
            />
          ))
        : Array.from(Array(5), (_, index) => (
            <SummaryMarqueeItem
              key={`marquee-loader-${index}`}
              category="BliKI"
              title={'Lass dir die wichtigsten News zusammenfassen'}
            />
          ))
  }, [data, loading, hasError])

  return (
    <>
      <StyledNewSummaryRequestView>
        <SummaryMarquee>{MarqueeContent}</SummaryMarquee>
        <StyledPrimaryCTAButton
          type="button"
          size="large"
          onClick={onPrimaryClick}
          iconName="stars"
          colorVariant="white">
          {translate('articleSummary.collapseContent.new')}
        </StyledPrimaryCTAButton>
      </StyledNewSummaryRequestView>
    </>
  )
}

export default NewSummaryRequestView
